import { getCloudinaryThemeFileUrl } from '@/integrations/cloudinary/helpers'
import { TitleDecorationProps } from 'components/cms/TitleDecoration/TitleDecoration'

const TitleDecoration = ({ className = '' }: TitleDecorationProps) => {
  return (
    <>
      <div className={`divider-wrap ${className}`}>
        <div className={`divider`} />
      </div>
      <style jsx>
        {`
          .divider-wrap {
            position: relative;
            height: 50px;
          }
          .divider {
            text-align: center;
            padding: 0;
            background-image: url(${getCloudinaryThemeFileUrl('images/elements/divider-short.png')});
            height: 50px;
            background-repeat: no-repeat;
            background-size: auto 50px;
            margin-left: calc(-50vw + 50% + 7px);
            width: calc(100vw - 15px);
          }
        `}
      </style>
    </>
  )
}

export default TitleDecoration
